import { Form as FormAnt, FormProps as AntFormProps } from 'antd';

interface FormProps {
  children: React.ReactNode;
  formProps?: AntFormProps;
}

export const Form = ({ children, formProps }: FormProps) => (
  <FormAnt
    {...formProps}
    className={`w-100 ${formProps?.className ? formProps?.className : ''}`}
    labelCol={formProps?.labelCol ?? { span: 24 }}
    wrapperCol={formProps?.wrapperCol ?? { span: 24 }}
  >
    {children}
  </FormAnt>
);
